import PageSeo from '@/seo/PageSeo';
import { searchContext } from '../context/Context';
import Loader from '../components/Common/Loader';
import AdvancedSearchContainer from '@/components/AdvancedSearch/AdvancedSearchContainer';

export default function AdvancedSearchPage() {
  const { loading, error } = searchContext();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="error-message">An error occurred: {error.message}</div>;
  }

  return (
    <>
      <PageSeo
        title="Advanced Search for Gene-Disease Associations | DISGENET"
        description="Build multi-entity queries across genes, diseases and variants in the DISGENET gene-disease association database."
        path="/advancedSearch"
      />
      <div className="p-4 advanced-research container-view">
        <div className="search-results-container">
          <AdvancedSearchContainer />
        </div>
      </div>
    </>
  );
}
